module.exports = __webpack_public_path__ + "img/punto-14.c0cabf32.png";